<!--  -->
<template>
  <div>
    <div class="hzuse_box">
      <div class="dasdnum">
        转盘格数：
      </div>
      <div>
        <el-radio-group
          v-model="radio"
          @change="numcaher"
        >
          <el-radio :label="8">8个</el-radio>
          <!-- <el-radio :label="6">6个</el-radio>
          <el-radio :label="8">8个</el-radio> -->
        </el-radio-group>
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        转盘标题：
      </div>
      <div>
        <el-input
          v-model="alltitle"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        分享标题：
      </div>
      <div>
        <el-input
          v-model="share_title"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        分享图片：
      </div>
      <div>
        <div>
          <img
            v-if="share_image!=null"
            :src="isharepath"
            alt=""
            style="width:100px;height:100px"
          >
        </div>
        <div>
          <!-- <el-button
            type="primary"
            size="mini"
            icon="el-icon-upload"
            @click="$refs.filer.click()"
          >上传<input
              ref="filer"
              style="display:none;"
              type="file"
              multiple
              accept="image/gif,image/jpg,image/jpeg,image/png"
              @change="uploadPicturesone"
            ></el-button> -->
          <el-button
            type="primary"
            size="mini"
            @click="chooseimgclickr(1)"
          >上传</el-button>
        </div>
      </div>
    </div>
    <!-- <div class="hzuse_box">
      <div class="dasdnum">
        背景图片地址：
      </div>
      <div>
        <el-input v-model="bgpic" style="width:400px" placeholder="请输入内容" />
      </div>
    </div> -->
    <div class="hzuse_box">
      <div class="dasdnum">
        客服链接：
      </div>
      <div>
        <el-input
          v-model="link"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        玩法说明：
      </div>
      <div style="width:400px">
        <el-input
          v-model="explain"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        每日抽奖次数：
      </div>
      <div>
        <el-input
          v-model="daily"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        立即抽奖次数：
      </div>
      <div>
        <el-input
          v-model="immediately"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        书币兑换门槛(普通用户)：
      </div>
      <div>
        <el-input
          v-model="ordinary"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        书币兑换门槛(vip用户)：
      </div>
      <div>
        <el-input
          v-model="vipordinary"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>

    <div class="hzuse_box">
      <div class="dasdnum">
        每月最多兑换次数：
      </div>
      <div>
        <el-input
          v-model="mostnum"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        每日提取书币的次数：
      </div>
      <div>
        <el-input
          v-model="daily_fetch_times"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        每次提取书币的个数：
      </div>
      <div>
        <el-input
          v-model="fetch_num_one_time"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        分享按钮文字：
      </div>
      <div>
        <el-input
          v-model="share_text"
          style="width:400px"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        我的团队按钮文字：
      </div>
      <div>
        <el-input
          v-model="team_text"
          style="width:400px"
          placeholder="进入我的团队按钮文字"
        />
      </div>
    </div>
    <div class="hzuse_box">
      <div class="dasdnum">
        控制先看广告还是领取书币：
      </div>
      <div>
        <el-radio-group v-model="ad_first">
          <el-radio-button :label="1">先看广告,在领取</el-radio-button>
          <el-radio-button :label="2">先领取,在看广告</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <div class="idpada_box">
      <div
        v-for="item,index in updata"
        :key="index"
      >
        <div class="sdaf_bdew">
          <div class="serialnumber">
            {{ index + 1 }}
          </div>

          <div class="hzuse_box">
            <div class="dasdnumr">
              上传图片：
            </div>
            <div>
              <!-- <el-button type="primary" size="mini" @click="$refs.file[index].click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures($event,index)"></el-button> -->
              <!-- <div
                class="updata_box"
                @click="$refs.file[index].click()"
              >
                <i
                  v-if="item.path == ''"
                  class="el-icon-upload"
                  style="font-size:30px"
                />
                <el-image
                  v-else
                  class="idawupdataimg"
                  :src="item.path"
                  :fit="'contain'"
                />
                <input
                  ref="file"
                  style="display:none;"
                  type="file"
                  multiple
                  accept="image/gif,image/jpg,image/jpeg,image/png"
                  @change="uploadPictures($event,index)"
                >
              </div> -->
              <div
                class="updata_box"
                @click="chooseimgclickr(2,index)"
              >
                <i
                  v-if="item.path == ''"
                  class="el-icon-upload"
                  style="font-size:30px"
                />
                <el-image
                  v-else
                  class="idawupdataimg"
                  :src="item.path"
                  :fit="'contain'"
                />
              </div>

            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              标题：
            </div>
            <div>
              <el-input
                v-model="item.name"
                placeholder="请输入内容"
              />
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              概率：
            </div>
            <div>
              <el-input
                v-model="item.probability"
                placeholder="请输入内容"
              />
            </div>
            <div>
              /万
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              书币数量：
            </div>
            <div>
              <el-input
                v-model="item.bookCurrency"
                placeholder="请输入内容"
              />
            </div>
          </div>
          <div class="hzuse_box">
            <div style="margin-left:15px">
              每日中奖次数：
            </div>
            <div>
              <el-input
                v-model="item.daily_times"
                placeholder="请输入内容"
              />
            </div>
          </div>
        </div>

      </div>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="submitclick"
      >确 定</el-button>
    </span>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
  </div>
</template>

<script>
import { qiniuToken } from '@/api/qiniuToken.js'
import { newMaterial, createninesquaresconfig, updatanineconfig } from '@/api/sourceMaterial.js'
import * as qiniu from 'qiniu-js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
export default {
  components: { chooseimg },
  mixins: [getNowDate],
  data() {
    return {
      updata: [], // 渲染数量数组
      token: null, // 上传图片token
      picupdataindex: null, // 上传图片index
      radio: 8, // 转盘数量
      num: 0, // 概率校验
      alltitle: '', // 标题
      // bgpic: '', // 背景图片地址
      link: '', // 链接
      explain: '', // 玩法说明
      daily: '', // 每日抽奖次数
      immediately: '', // 立即抽奖次数
      ordinary: '', // 书币兑换门槛(普通用户)
      vipordinary: '', // 书币兑换门槛(vip用户)
      mostnum: '', // 每月最多兑换次数
      daily_fetch_times: '', // 每日提取书币的次数
      fetch_num_one_time: '', // 每次提取书币的个数
      ad_first: 1, // 控制先看广告还是先抽书币 1先看广告 2先领取
      zhengdata: [],
      type: null, // 新增 编辑类型
      ids: null, // 编辑的id
      share_title: '', // 分享标题
      isharepath: '',
      share_image: null,
      share_text: '', // 分享按钮文字
      team_text: '', // 进入我的团队按钮
      chuantype: null,
      dialogVisibletwo: false
    }
  },
  created() {
    this.numcaher(this.radio)
    this.getQiniuToken()
  },
  mounted() {},
  methods: {
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    numcaher(val) {
      console.log('val', val)
      const arr = []
      this.updata = []
      for (let i = 0; i < val; i++) {
        arr.push({
          path: '', // 图片显示
          picture: '', // 要传图片的id
          name: '', // 标题
          probability: '', // 概率
          bookCurrency: '', // 书币个数
          daily_times: '' // 每项奖品每日中奖次数
        })
      }
      // arr[0].bookCurrency = 5
      // arr[1].bookCurrency = 10
      // arr[2].bookCurrency = 30
      // arr[3].bookCurrency = 50
      // arr[0].name = '5书币'
      // arr[1].name = '10书币'
      // arr[2].name = '30书币'
      // arr[3].name = '50书币'
      // arr[0].img = require('@/assets/larke/5coin.png')
      // arr[1].img = require('@/assets/larke/10coin.png')
      // arr[2].img = require('@/assets/larke/30coin.png')
      // arr[3].img = require('@/assets/larke/50coin.png')
      this.updata = arr
      console.log(arr, arr)
    },
    async uploadPictures(e, index) {
      console.log(e.target.files[0], index)
      this.picupdataindex = index
      const fileIfon = e.target.files[0]
      const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.updata[this.picupdataindex].img = temporary
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      const observable = qiniu.upload(
        fileIfon,
        `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
        this.token,
        {
          fname: fileIfon.name // 文件名
        },
        {
          useCdnDomain: true // cdn域名加速
        }
      )
      observable.subscribe({
        next() {},
        error(err) {
          console.log(err)
        },
        complete: data => {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          console.log('data', data)
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(res => {
            console.log('res', res)
            this.updata[this.picupdataindex].path = res.data.path
            this.updata[this.picupdataindex].picture = res.data.sourceMaterialId
          })
        }
      })
    },
    async submitclick() {
      console.log('this.updata', this.updata)

      const data = this.updata.map(item1 => {
        return { name: item1.name, probability: item1.probability, bookCurrency: item1.bookCurrency, picture: item1.picture, path: item1.path, daily_times: item1.daily_times }
      })
      this.zhengdata = data
      console.log('JSON.stringify(this.zhengdata)', JSON.stringify(this.zhengdata))

      if (this.alltitle === '') {
        this.$message.error('请填写转盘标题')
        return
      }
      if (this.share_title === '') {
        this.$message.error('请填写分享标题')
        return
      }
      // if (this.bgpic === '') {
      //   this.$message.error('请填写背景图片地址')
      //   return
      // }
      if (this.link === '') {
        this.$message.error('请填写客服链接')
        return
      }
      if (this.explain === '') {
        this.$message.error('请填写玩法说明')
        return
      }
      if (this.daily === '') {
        this.$message.error('请填写每日抽奖次数')
        return
      }
      if (this.immediately === '') {
        this.$message.error('请填写立即抽奖次数')
        return
      }
      if (this.ordinary === '') {
        this.$message.error('请填写书币兑换门槛(普通用户)')
        return
      }
      if (this.vipordinary === '') {
        this.$message.error('请填写书币兑换门槛(vip用户)')
        return
      }
      if (this.mostnum === '') {
        this.$message.error('请填写每月最多兑换次数')
        return
      }
      if (this.daily_fetch_times === '') {
        this.$message.error('请填写每日提取书币的次数')
        return
      }
      if (this.fetch_num_one_time === '') {
        this.$message.error('请填写每次提取书币的个数')
        return
      }
      if (this.share_text === '') {
        this.$message.error('请填写分享按钮文案')
        return
      }
      if (this.team_text === '') {
        this.$message.error('请填写分享按钮文案')
        return
      }
      const isTrue = this.updata.every(function (v, i, arr) {
        return v.name !== ''
      })
      if (isTrue === false) {
        this.$message.error('请填写标题')
        return
      }
      const isTruer = this.updata.every(function (v, i, arr) {
        return v.probability !== ''
      })
      if (isTruer === false) {
        this.$message.error('请填写概率')
        return
      }
      this.num = 0
      this.updata.forEach(item => {
        this.num += Number(item.probability)
      })
      // eslint-disable-next-line eqeqeq
      if (this.num != 10000) {
        this.$message.error('概率加一起要总共为一万')
        return
      }
      const isTruere = this.updata.every(function (v, i, arr) {
        return v.bookCurrency !== ''
      })
      if (isTruere === false) {
        this.$message.error('请填写书币数量')
        return
      }

      const isTruonece = this.updata.every(function (v, i, arr) {
        return v.daily_times !== ''
      })
      if (isTruonece === false) {
        this.$message.error('请填写每日中奖次数')
        return
      }
      if (this.type === 1 || this.type === 3) {
        const datar = await createninesquaresconfig({
          title: this.alltitle,
          share_title: this.share_title,
          share_image: this.share_image,
          // backgroundPic: this.bgpic,
          customer_service_url: this.link,
          play_instructions: this.explain.replace(/\n/g, '<br/>'),
          // prize: JSON.stringify(this.zhengdata),
          prize: this.zhengdata,
          raffle_number: this.daily,
          immediately_number: this.immediately,
          book_currency_exchange: this.ordinary,
          book_currency_exchange_vip: this.vipordinary,
          exchange_number: this.mostnum,
          daily_fetch_times: this.daily_fetch_times,
          fetch_num_one_time: this.fetch_num_one_time,
          ad_first: this.ad_first,
          share_text: this.share_text,
          team_text: this.team_text
        })
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('close')
        console.log('datar', datar)
      } else {
        const datarr = await updatanineconfig({
          title: this.alltitle,
          share_title: this.share_title,
          share_image: this.share_image,
          // backgroundPic: this.bgpic,
          customer_service_url: this.link,
          play_instructions: this.explain.replace(/\n/g, '<br>'),
          prize: this.zhengdata,
          raffle_number: this.daily,
          immediately_number: this.immediately,
          book_currency_exchange: this.ordinary,
          book_currency_exchange_vip: this.vipordinary,
          exchange_number: this.mostnum,
          daily_fetch_times: this.daily_fetch_times,
          fetch_num_one_time: this.fetch_num_one_time,
          ad_first: this.ad_first,
          share_text: this.share_text,
          team_text: this.team_text,
          id: this.ids
        })
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        this.$emit('close')
        console.log('编辑', datarr)
      }

      // console.log('num', this.num)
    },
    send(val, item) {
      console.log('传', val)
      this.type = val
      if (val === 1) {
        console.log('新增')
      } else {
        console.log('编辑', item, item.prize.length)
        this.radio = item.prize.length
        this.ids = item.id
        // item.prize[0].img = require('@/assets/larke/5coin.png')
        // item.prize[1].img = require('@/assets/larke/10coin.png')
        // item.prize[2].img = require('@/assets/larke/30coin.png')
        // item.prize[3].img = require('@/assets/larke/50coin.png')
        this.updata = item.prize
        this.alltitle = item.title
        this.share_title = item.share_title
        this.link = item.customer_service_url
        this.explain = item.play_instructions.replace(/<br>/g, '\n')
        this.daily = item.raffle_number
        this.immediately = item.immediately_number
        this.ordinary = item.book_currency_exchange
        this.vipordinary = item.book_currency_exchange_vip
        this.mostnum = item.exchange_number
        this.daily_fetch_times = item.daily_fetch_times
        this.fetch_num_one_time = item.fetch_num_one_time
        this.ad_first = item.ad_first
        this.isharepath = item.share_image_url
        this.share_image = item.share_image
        this.share_text = item.share_text
        this.team_text = item.team_text
      }
    },
    uploadPicturesone(e) {
      console.log('e', e)
      const fileIfon = e.target.files[0]
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      console.log('temporary', temporary)
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const observable = qiniu.upload(
        fileIfon,
        `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
        this.token,
        {
          fname: fileIfon.name // 文件名
        },
        {
          useCdnDomain: true // cdn域名加速
        }
      )
      observable.subscribe({
        next() {},
        error(err) {
          console.log(err)
        },
        complete: data => {
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(res => {
            console.log('res', res)
            this.$message({
              type: 'success',
              message: '上传成功!'
            })
            this.isharepath = res.data.path
            this.share_image = res.data.sourceMaterialId
          })
        }
      })
    },
    chooseimgclickr(type, index) {
      this.chuantype = type
      this.dialogVisibletwo = true
      if (type === 2) {
        this.picupdataindex = index
      }
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      console.log(img, key)
      if (this.chuantype === 1) {
        this.isharepath = img
        this.share_image = key
      } else {
        this.updata[this.picupdataindex].path = img
        this.updata[this.picupdataindex].picture = key
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.hzuse_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.dasdnum {
  font-size: 15px;
  color: #606266;
  width: 200px;
  text-align: right;
}
.dasdnumr {
  font-size: 15px;
  color: #606266;
  width: 76px;
  text-align: right;
}
.sdaf_bdew {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.idawupdataimg {
  width: 100%;
  height: 100%;
}
.idpada_box {
  height: 480px;
  overflow: scroll;
  overflow-x: hidden;
}
.idpada_box::-webkit-scrollbar {
  width: 10px;
  background-color: #fff;
}
.idpada_box:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #fff;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.idpada_box:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}
.idpada_box:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #ccc;
  border-radius: 6px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
}
.serialnumber {
  padding-bottom: 18px;
  font-size: 17px;
  margin-right: 10px;
}
/deep/ .el-textarea__inner {
  min-height: 100px !important;
}
.updata_box {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  text-align: center;
  line-height: 110px;
  border-radius: 5px;
}
.updata_box:hover {
  border: 1px dashed #1890ff;
}
</style>
